import React, { useState, useRef } from "react"
import styled, { css } from 'styled-components'
import { usePrevious, useMeasure } from '../../../../../hooks'
import { useSpring, useChain, animated as a } from 'react-spring'

import arrow from '../../../../../images/icons/arrow.svg'

const Frame = styled.li`
  ${({ theme: { breakpoints } }) => css`
    padding: 3.6rem 2.4rem;
    background-color: #fff;
    overflow: hidden;
    cursor: pointer;
    border-radius: 1.2rem;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    & + & {
      margin-top: 4.0rem;
    }
    @media (min-width: ${breakpoints.md}px) {
      padding: 3.6rem 4.8rem;
    }
  `}
`
const TitleWrapper = styled.div`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    justify-content: space-between;
    img {
      width: 2.2rem;
      height: 2.2rem;
    }
  `}
`
const Title = styled.h3`
  font-size: 2.0rem;
  line-height: 2.0rem;
`
const InnerContent = styled(a.div)`
`

const Accordion = ({ children, open, ...props }) => {
  const [isOpen, setOpen] = useState(open ? open : false)
  const previous = usePrevious(isOpen)
  const [bind, { height: viewHeight }] = useMeasure()

  const outerRef = useRef()
  const { height, angle } = useSpring({
    ref: outerRef,
    from: { height: 0, angle: 0}, 
    to: { height: isOpen ? viewHeight : 0, angle: isOpen ? 180 : 0 }
  })
  const innerRef = useRef()
  const { opacity, transform } = useSpring({
    ref: innerRef,
    from: { opacity: 0, transform: 'translate3d(0,-20px,0)' }, 
    to: { opacity: isOpen ? 1 : 0, transform: `translate3d(0,${isOpen ? 0 : -20}px,0)`}
  })
  useChain(isOpen ? [outerRef, innerRef] : [innerRef, outerRef], [0, 0.3])

  const { title } = props
  return (
    <Frame onClick={() => setOpen(!isOpen)}>
      <TitleWrapper>
        <Title>{title}</Title>
        <a.img src={arrow} alt="" style={{ transform: angle.interpolate(x => `rotateX(${x}deg)`) }} />
      </TitleWrapper>
      <InnerContent style={{ opacity, height: isOpen && previous === isOpen ? 'auto' : height }}>
        <a.div style={{ transform }} {...bind}>
          {children}
        </a.div>
      </InnerContent>
    </Frame>
  )
}

// const SpringItem = ({ children, title }) => {
//   const [isOpen, setOpen] = useState(false)
//   const [contentMaxHeight, setContentMaxHeight] = useState(0);
//   const ref = useRef();

//   useEffect(() => {
//     const calcContentMaxHeight = () => {
//       ref && setContentMaxHeight(ref.current.scrollHeight)
//     }
//     calcContentMaxHeight()
//     window.addEventListener("resize", () => calcContentMaxHeight())
//     return () => window.addEventListener("resize", () => calcContentMaxHeight())
//   }, [ref, contentMaxHeight])

//   const outerRef = useRef()
//   const { height, angle } = useSpring({
//     ref: outerRef,
//     from: { height: 0, angle: 0}, 
//     to: { height: isOpen ? contentMaxHeight : 0, angle: isOpen ? 180 : 0 }
//   })
//   const innerRef = useRef()
//   const { opacity, transform } = useSpring({
//     ref: innerRef,
//     from: { opacity: 0, transform: 'translateY(-20px)' }, 
//     to: { opacity: isOpen ? 1 : 0, transform: `translateY(${isOpen ? 0 : -20}px)`}
//   })
//   useChain(isOpen ? [outerRef, innerRef] : [innerRef, outerRef], [0, 0.3])

//   return (
//     <Frame onClick={() => setOpen(!isOpen)}>
//       <TitleWrapper>
//         <Title>{title}</Title>
//         <a.img src={arrow} alt="" style={{ transform: angle.interpolate(x => `rotateX(${x}deg)`) }} />
//       </TitleWrapper>
//       <InnerContent ref={ref} style={{ height, opacity }}>
//         <a.div style={{ transform }} children={children} />
//       </InnerContent>
//     </Frame>
//   )
// }

export default Accordion